import { FormGroup, Radio, RadioGroup } from '@ksyos/design-system';
import type { OsasTreatmentData } from '@common/validation/customControls/osas/osasTreatmentChoice/types';
import type { ValidationErrors } from '@frontend/utils';
import { getValidationErrorTranslation } from '@frontend/utils';
import type { TreatmentDescription, TreatmentOptionsKeys } from './utils';
import { TreatmentClassInformation } from './TreatmentClassInformation';
import { treatmentOptions } from './utils';

type TreatmentRadioGroupProps = {
    data: OsasTreatmentData;
    errors: ValidationErrors;
    onChange: (data: Partial<OsasTreatmentData>, validateKeys?: string | string[] | undefined) => void;
    treatmentName: TreatmentOptionsKeys;
};

export function TreatmentRadioGroup(props: Readonly<TreatmentRadioGroupProps>) {
    const { data, errors, onChange, treatmentName } = props;
    const treatmentObject = treatmentOptions[treatmentName];

    const hasErrors = Boolean(data.treatment[treatmentName]) && errors.has(`treatment.${treatmentName}`);

    return (
        <FormGroup
            hasErrors={hasErrors}
            isRequired={true}
            key={`${treatmentName}-radio-group`}
            label="Type behandeling"
        >
            <RadioGroup
                error={hasErrors ? getValidationErrorTranslation(errors.get(`treatment.${treatmentName}`)) : undefined}
                layout="column"
                name={'treatment'}
                onChange={({ target: { value } }) => {
                    onChange(
                        {
                            treatment: { ...data.treatment, [treatmentName]: value },
                            treatmentFollowUp: {
                                ...data.treatmentFollowUp,
                                [treatmentName]:
                                    treatmentObject.find((treatment) => treatment.label === value)?.followUp ?? null,
                            },
                        },
                        ['treatment', `treatment.${treatmentName}`]
                    );
                }}
                value={data.treatment[treatmentName].toString() ?? ''}
            >
                {treatmentObject.map((treatmentClass) =>
                    getTreatmentClassRadioButton(treatmentClass, data.treatment[treatmentName] === treatmentClass.label)
                )}
            </RadioGroup>
        </FormGroup>
    );

    function getTreatmentClassRadioButton(treatment: TreatmentDescription, isClassChecked: boolean) {
        return (
            <Radio
                checked={isClassChecked}
                key={treatment.label}
                label={
                    <>
                        {treatment.label}
                        <TreatmentClassInformation
                            isChecked={isClassChecked}
                            treatment={treatment}
                        />
                    </>
                }
                onChange={() => {}}
                sx={{ alignItems: 'flex-start' }}
                value={treatment.label}
            />
        );
    }
}
